import * as React from "react";
import {
  Modal,
  Spin,
  Layout,
  Input,
  TimePicker,
  Select,
  notification,
  Button,
  Divider,
} from "antd";
import { Formik, FieldProps, Field } from "formik";

const { Content } = Layout;
const { TextArea } = Input;

export class AddSingleUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      data: [],
      recordDetails: {},
      isLoading: false, // Fixme this should be true
      closable: true,
    };
  }

  componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }
  }

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.hide();
  };

  show() {
    this.setState({
      visible: true,
    });
  }

  hide() {
    this.setState({
      visible: false,
    });
    this.props.onClose();
  }

  validateForm = (values) => {
    const errors = {};
    console.log("Validating form -- ", values);

    if (!values.singpass_id) {
      errors.singpass_id = "SingpassId is required";
    }

    if (!values.principal_name) {
      errors.principal_name = "Principal name is required";
    }

    if (!values.mobile_number) {
      errors.mobile_number = "Mobile number is required";
    }

    if (!values.email) {
      errors.email = "Email is required";
    }

    if (!values.race) {
      errors.race = "Race is required";
    }

    if (!values.sex) {
      errors.sex = "Sex is required";
    }

    if (!values.nationality) {
      errors.nationality = "Nationality is required";
    }

    console.log("Validating errors -- ", errors);
    return errors;
  };

  handleSubmit = async (values, action) => {
    this.props.onSubmit(values);

    this.setState({
      visible: false,
    });
  };

  render() {
    return (
      // <StyleBox>
      <Modal
        width="600px"
        closable={this.state.closable}
        visible={this.state.visible}
        title="Add a Single Supervisor"
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={null}
        destroyOnClose={true}
      >
        {this.state.isLoading ? (
          <div style={{ justifyContent: "center" }}>
            <Spin />
          </div>
        ) : (
          <div>
            <Content style={{ background: "#fff", marginLeft: "10px" }}>
              <Formik
                initialValues={{
                  singpass_id: "",
                  principal_name: "",
                  mobile_number: "",
                  email: "",
                  race: "",
                  sex: "",
                  nationality: "",
                  type_of_hdb: "",
                  type_of_housing: "",
                  maritial_status: "",
                  address: "",
                }}
                validate={this.validateForm}
                onSubmit={this.handleSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                  setFieldTouched,
                  isSubmitting,
                }) => {
                  return (
                    <div>
                      <div className="formik-field_wrap">
                        <div className="formik-field-left">
                          SingPass Id
                          <Input
                            id="singpass_id"
                            placeholder="SingPass Id"
                            value={values.singpass_id}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.singpass_id && touched.singpass_id ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.singpass_id}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="formik-field_wrap">
                        <div className="formik-field-left">
                          Name
                          <Input
                            id="principal_name"
                            placeholder="Name"
                            value={values.principal_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.principal_name && touched.principal_name ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.principal_name}
                            </p>
                          ) : null}
                        </div>
                        <div className="formik-field-right">
                          Email
                          <Input
                            id="email"
                            placeholder="Email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.email && touched.email ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.email}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="formik-field_wrap">
                        <div className="formik-field-left">
                          Mobile Number
                          <Input
                            id="mobile_number"
                            placeholder="Mobile Number"
                            value={values.mobile_number}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.mobile_number && touched.mobile_number ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.mobile_number}
                            </p>
                          ) : null}
                        </div>
                        <div className="formik-field-right">
                          Nationality
                          <Input
                            id="nationality"
                            placeholder="Nationality"
                            value={values.nationality}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.nationality && touched.nationality ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.nationality}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="formik-field_wrap">
                        <div className="formik-field-left">
                          Race
                          <Input
                            id="race"
                            placeholder="Race"
                            value={values.race}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.race && touched.race ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.race}
                            </p>
                          ) : null}
                        </div>
                        <div className="formik-field-right">
                          Sex
                          <Input
                            id="sex"
                            placeholder="Sex"
                            value={values.sex}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.sex && touched.sex ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.sex}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="formik-field_wrap">
                        <div className="formik-field-left">
                          Type of HDB
                          <Input
                            id="type_of_hdb"
                            placeholder="Type of HDB"
                            value={values.type_of_hdb}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.type_of_hdb && touched.type_of_hdb ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.type_of_hdb}
                            </p>
                          ) : null}
                        </div>
                        <div className="formik-field-right">
                          Type of Housing
                          <Input
                            id="type_of_housing"
                            placeholder="Type of Housing"
                            value={values.type_of_housing}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.type_of_housing && touched.type_of_housing ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.type_of_housing}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="formik-field_wrap">
                        <div className="formik-field-left">
                          Maritial Status
                          <Input
                            id="maritial_status"
                            placeholder="Maritial Status"
                            value={values.maritial_status}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.maritial_status && touched.maritial_status ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.maritial_status}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="formik-field_wrap">
                        <div className="formik-field-left" style={{ width: "100%" }}>
                          Address
                          <TextArea
                            id="address"
                            placeholder="Address"
                            rows={3}
                            value={values.address}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>

                      <Button
                        // type="primary"
                        style={{
                          marginTop: "19px",
                          background: "#5C6AC4",
                          color: "#fff",
                        }}
                        onClick={handleSubmit}
                      >
                        Add
                      </Button>
                    </div>
                  );
                }}
              </Formik>
            </Content>
          </div>
        )}
      </Modal>
    );
  }
}
